import { isString } from "lodash"
export default class {

    constructor(value, multiplier = 1) {
        if( isString(value) ) {
            value = value.replace(/[\$\,]/g, '')
        }
        this.value = new Number(value) * multiplier
    }

    display(decimals, format) {
        let dollars = new Number((this.value / 100).toFixed(2));
        if( decimals === undefined) {
            decimals = dollars % 1 !== 0 ? 2 : 0;
        }

        if (format === undefined) {
            format = {style: 'currency', currency: 'USD', maximumFractionDigits: decimals, minimumFractionDigits: decimals }
        }

        if (format === 'number') {
            format = {style: 'decimal', maximumFractionDigits: decimals, minimumFractionDigits: decimals, useGrouping: true }
        }

        return dollars.toLocaleString('en-US', format)
    }
}
